import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  emailHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    background: '#363473',
    height: '65px',
    alignItems: 'center',
    marginTop: '21.5px',
    marginBottom: '4.5px',
    padding: '0 46px',
  },
  ImageStyles: {
    height: '60px ',
    width: '60px !important',
  },
  IconEmail: {},
  callicon: {
    background: 'rgba(255, 255, 255, 0.1)',
    padding: '8px 7px',
    borderRadius: '4px',
    '& .MuiSvgIcon-root ': {
      color: 'white',
      height: '18px',
      widthh: '18px',
    },
  },
  footerText: {
    color: 'white',
    marginLeft: '8px',
  },
}));
